import React, { Fragment, useContext, useEffect, useState } from 'react'
import { GlobalContext, getLayoutMode } from '../context/globalContext'
import allMenuMaps from '../layout/menus'
import * as R from 'ramda'
import AlertPage from '../pages/shared/alertPage'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import tremSession from '../util/tremSession'
import G from '../util/globalFunction'

const NotLogin = props => (
    <AlertPage message={G.t('trem.lang.home.0909')}> {/* 로그인이 필요한 화면입니다. */}
        <div className="mx-auto text-xl">
            <span className="mr-2">{G.t('trem.lang.home.0910')}</span>{/* 로그인 화면으로 이동 */}
            <Link to="/login">
                <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    </AlertPage>
)

const AuthError = props => (
    <AlertPage message={G.t('trem.lang.home.0911')}>{/* 로그인한 사용자가 권한이 없습니다. */}
        <div className="mx-auto text-xl">
            <span className="mr-2">{G.t('trem.lang.home.0910')}</span>{/* 로그인 화면으로 이동 */}
            <Link to="/login">
                <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    </AlertPage>
)

const AuthMgrError = props => (
    <AlertPage message={G.t('trem.lang.home.0912')}> {/* 관리자 권한만 사용가능합니다. */}
        <div className="mx-auto text-xl">
            <span className="mr-2">{G.t('trem.lang.home.0910')}</span>{/* 로그인 화면으로 이동 */}
            <Link to="/login">
                <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    </AlertPage>
)

// Guard는 무조건 로그인이 된 화면에서만 허용. 즉 로그인상태가 아닌 경우 Guard로 감싼 page는 로그인후 사용 가능
// /layout/menus에 속해 있는 page는 반드시 서버에서 가져온 허가된 page일 경우만
// 오픈이 가능하다. 즉 menu에 있으나 허가되지 않으면 허가되지 않은 Page 표시
// 만일 /layout/menus에 속해 있지 않은 page는 해당 guard의 permitType으로 결정한다.
// permitType : M:관리자만 사용

// 2021.11.16 임시처리 : 메뉴 등록 여부에 상관없이, permitType로 결정함. 
// +) GlobalContext loginInfo 사용 시 오류 발생하여 tremSession.getSessionInfo 사용하도록 변경
export default props => {
    const { children, permitType } = props
    const { loginInfo, layoutMode } = useContext(GlobalContext)
    const [guardSessionInfo, setGuardSessionInfo] = useState({})

    useEffect(() => {
        tremSession.getSessinInfo()
        .then(data => {
            setGuardSessionInfo(data)
        })
    }, [])

    const checkAuth = () => {
        const menuMap = {}
        const pathname = window.location.pathname
        const menus = menuMap[getLayoutMode()] || []
        const allmenu = allMenuMaps[getLayoutMode()]

        // console.log(
        //     'guard',
        //     menus,
        //     allmenu.map(({ menus }) => menus.map(({ route }) => route)).flat()
        // )

        let activMenuExists = false
        menus.forEach(menu => {
            if (menu.menus.find(({ route }) => route === pathname)) {
                activMenuExists = true
            }
        })
        let allMenuExists = false
        allmenu.forEach(menu => {
            if (menu.menus.find(({ route }) => route === pathname)) {
                allMenuExists = true
            }
        })
        return { activMenuExists, allMenuExists }
    }

    return R.ifElse(
        () => !guardSessionInfo?.loggined,
        () => <NotLogin />,
        R.pipe(checkAuth, ({ activMenuExists, allMenuExists }) =>
            R.cond([
                [() => allMenuExists === true && activMenuExists === false, () => <AuthError />],
                [() => permitType === 'M' && guardSessionInfo?.JOIN_TYPE !== permitType, () => <AuthMgrError />],
                [R.T, () => <Fragment>{children}</Fragment>],
            ])()
        )
    )()
}
